import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div>
            <nav className="navbar navbar-light bg-light shadow-sm px-3 d-flex justify-content-center">
                <div className="container d-flex align-items-center justify-content-between w-100">
                    <a className="navbar-brand fw-bold" href="/">LFRA App</a>
                    <div className="d-flex justify-content-center">
                        <a className="mx-3 text-decoration-none text-dark fw-bold" href="/">Home</a>
                        <a className="text-decoration-none text-dark fw-bold" href="/faq">FAQ</a>
                    </div>
                    <div className="invisible navbar-brand">
                        {/* <!-- This empty div helps balance the navbar --> */}
                    </div>
                </div>
            </nav>

            <div className="container mt-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h2>Privacy Policy</h2>
                </div>
                <div className="card shadow-sm p-4">

                    <h4 className="mt-4">1. Introduction</h4>
                    <p>Welcome to the <strong>LFRA App</strong>, the official Visitor Management platform for Lavington Five Roads Association (LFRA). Your privacy is important to us, and we are committed to protecting your personal information. This Privacy Policy outlines how we collect, use, store, and protect your data when you use the LFRA App.</p>

                    <h4 className="mt-4">2. Who can use the LFRA App</h4>
                    <p>The LFRA App can only be used by registered members of the Lavington Five Roads Association (LFRA). To be registred as a user, you must avail yourself to the LFRA main office physically to submit your user details for registration. No other individuals are authorized to use the LFRA App.</p>

                    <h4 className="mt-4">3. Information We Collect</h4>
                    <p>When using the LFRA App, we collect the following information:</p>
                    <ul>
                        <li><strong>Personal Information</strong>: Name, phone number and email address</li>
                    </ul>

                    <h4 className="mt-4">4. How We Use Your Information</h4>
                    <p>We use your data to:</p>
                    <ul>
                        <li>Facilitate visitor pre-authorization and secure entry.</li>
                        <li>Provide QR codes for quick identification at the gates.</li>
                        <li>Manage residents, family members, staff, and vehicles for efficient access control.</li>
                        <li>Enhance app security and prevent unauthorized access.</li>
                        <li>Improve the LFRA App through analytics and user feedback.</li>
                    </ul>

                    <h4 className="mt-4">5. How We Protect Your Data</h4>
                    <p>We implement industry-standard security measures, including:</p>
                    <ul>
                        <li><strong>Data Encryption</strong>: All sensitive data is encrypted in transit and at rest.</li>
                        <li><strong>Strict Access Controls</strong>: Access to data is role-based and limited to authorized personnel.</li>
                        <li><strong>Real-Time Monitoring</strong>: Continuous monitoring to detect and prevent security threats.</li>
                    </ul>

                    <h4 className="mt-4">6. Sharing of Information</h4>
                    <p>We do not sell your personal data. However, we may share information with:</p>
                    <ul>
                        <li><strong>LFRA Management and Security Teams</strong>: To facilitate visitor entry and ensure security.</li>
                        <li><strong>Legal Authorities</strong>: If required by law or in case of security incidents.</li>
                        <li><strong>Service Providers</strong>: For system maintenance and operational support, under strict confidentiality agreements.</li>
                    </ul>

                    <h4 className="mt-4">7. Your Rights and Choices</h4>
                    <p>As a user of the LFRA App, you have the right to:</p>
                    <ul>
                        <li><strong>Access and Update</strong>: You can review and update your personal information at any time.</li>
                        <li><strong>Opt-Out</strong>: You may disable certain app functionalities where applicable.</li>
                        <li><strong>Data Deletion</strong>: You can request the deletion of your personal data, subject to legal obligations.</li>
                    </ul>

                    <h4 className="mt-4">8. Data Retention</h4>
                    <p>We retain your data only as long as necessary for security and operational purposes. Visitor logs are securely stored and automatically deleted after a defined period, unless required for legal or security investigations.</p>

                    <h4 className="mt-4">9. Changes to This Policy</h4>
                    <p>LFRA reserves the right to update this Privacy Policy periodically. Any changes will be communicated through the app, and continued use constitutes acceptance of the updated terms.</p>

                    <h4 className="mt-4">10. Contact Us</h4>
                    <p>If you have any questions regarding this Privacy Policy, please contact us at:</p>
                    <p><strong>Lavington Five Roads Association (LFRA)</strong><br />
                        <strong>Phone</strong>:   +254 705886565<br />
                    </p>

                    <p className="mt-4"><strong>By using the LFRA App, you agree to the terms outlined in this Privacy Policy.</strong></p>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
